const INVALID_CONTROL_SELECTOR = '[aria-invalid="true"]'
const MAX_FOCUS_ATTEMPTS = 2

const focusFirstInvalidControl = (form: HTMLFormElement | null): void => {
  let attempt = 0

  const tryFocus = (): void => {
    const invalidControls = form?.querySelectorAll<HTMLElement>(
      INVALID_CONTROL_SELECTOR,
    )

    for (const control of invalidControls ?? []) {
      if (
        control.matches(':disabled, [aria-disabled="true"]') ||
        control.tabIndex < 0 ||
        control.hidden
      ) {
        continue
      }

      control.focus()
      if (form?.ownerDocument.activeElement === control) return
    }

    attempt += 1
    if (invalidControls?.length && attempt < MAX_FOCUS_ATTEMPTS) {
      window.requestAnimationFrame(tryFocus)
    }
  }

  window.requestAnimationFrame(tryFocus)
}

export { focusFirstInvalidControl }
